// dependencies
import React from "react";
import withMedia, { WithMediaInjectedPropsType } from "../../hocs/withMedia";

// components
import FullComment from "./FullComment";
import ResponsiveComment from "./ResponsiveComment";

type PropsType = {
  publishedAt: Date;
  customerFullname: string;
  ownerFullname: string;
  averageRate: number;
  fairnessRate: number;
  greetingRate: number;
  cosinessRate: number;
  qualityRate: number;
  title: string;
  customerContent: string;
  ownerContent: string;
  agentContent: string;
  composition: string;
} & WithMediaInjectedPropsType;

const Comment: React.FunctionComponent<PropsType> = (props) => {
  const {
    matches,
    publishedAt,
    fairnessRate,
    greetingRate,
    cosinessRate,
    averageRate,
    qualityRate,
    title,
    customerContent,
    customerFullname,
    ownerFullname,
    ownerContent,
    agentContent,
    composition,
  } = props;

  return matches ? (
    <FullComment
      publishedAt={publishedAt}
      fairnessRate={fairnessRate}
      greetingRate={greetingRate}
      cosinessRate={cosinessRate}
      averageRate={averageRate}
      qualityRate={qualityRate}
      title={title}
      customerContent={customerContent}
      customerFullname={customerFullname}
      ownerFullname={ownerFullname}
      ownerContent={ownerContent}
      agentContent={agentContent}
      composition={composition}
    />
  ) : (
    <ResponsiveComment
      publishedAt={publishedAt}
      fairnessRate={fairnessRate}
      greetingRate={greetingRate}
      cosinessRate={cosinessRate}
      averageRate={averageRate}
      qualityRate={qualityRate}
      title={title}
      customerContent={customerContent}
      customerFullname={customerFullname}
      ownerFullname={ownerFullname}
      ownerContent={ownerContent}
      agentContent={agentContent}
      composition={composition}
    />
  );
};

export default withMedia({
  query: { minWidth: 700 },
  breakpointType: "element",
})(Comment);
